import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-32 px-6 relative overflow-hidden" data-id="element-106">
      {/* Gold glow background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-107" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center justify-center p-4 bg-gold-500/10 rounded-full mb-8 border border-gold-500/20" data-id="element-109">
          <ShieldCheckIcon className="w-12 h-12 text-gold-400" data-id="element-110" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-4xl md:text-6xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-400" data-id="element-111">
          El Sistema de Blindaje 18-24
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="p-8 md:p-12 bg-white/[0.02] border border-gold-500/20 rounded-3xl backdrop-blur-sm" data-id="element-112">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed" data-id="element-113">
            Este no es un aburrido libro de economía. Es un manual operativo que
            utiliza las reglas del sistema financiero de Estados Unidos —el
            crédito, el interés compuesto y las exenciones fiscales— para crear
            una estructura de protección alrededor de tu primer sueldo.{' '}
            <strong className="text-gold-400 font-normal" data-id="element-114">
              Aprenderás a usar el sistema a tu favor, convirtiendo cada dólar
              en un empleado que trabaja para ti 24/7.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}